import React, { useEffect } from "react";
import Routes from "./Routes";
import { Toaster } from "react-hot-toast";
import "leaflet/dist/leaflet.css";
import { initFirebaseMessaging } from "firebase";

function App() {
  useEffect(() => {
    initFirebaseMessaging();
  }, []);
  return (
    <>
    <Toaster
  position="top-right"
  reverseOrder={false}
  toastOptions={{
    duration: 4000, 
    style: {
      fontFamily: 'Cairo, sans-serif',
      fontWeight: '500',
      fontSize: '14px',
      textAlign: 'right',
      direction: 'rtl',
    },
  }}
/>
       <Routes />
    </>
   
  );
}

export default App;
